import sha256 from "crypto-js/sha256";

export const getStationIdShortHash = stationId => {
    return sha256(stationId).toString().slice(0, 5);
};
